// extracted by mini-css-extract-plugin
export var tableWrapper = "comparisonTable-module--tableWrapper--96644";